var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoControlMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#545454"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 20.917C19.8415 20.917 21.3332 19.4253 21.3332 17.5837V13.0003C21.3332 11.1587 19.8415 9.66699 17.9998 9.66699C16.1582 9.66699 14.6665 11.1587 14.6665 13.0003V17.5837C14.6665 19.4253 16.1582 20.917 17.9998 20.917Z",
    stroke: "#F6F6F6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 16.042V17.4587C11.625 20.9753 14.4833 23.8337 18 23.8337C21.5167 23.8337 24.375 20.9753 24.375 17.4587V16.042",
    stroke: "#F6F6F6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8418 13.3586C17.5918 13.0836 18.4085 13.0836 19.1585 13.3586",
    stroke: "#F6F6F6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3335 15.1246C17.7752 15.0079 18.2335 15.0079 18.6752 15.1246",
    stroke: "#F6F6F6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.833V26.333",
    stroke: "#F6F6F6",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoControlMic);
export default __webpack_public_path__ + "static/media/icon_video_control_mic.2c3bfd17d9a09a068d33b4c6211409ed.svg";
export { ForwardRef as ReactComponent };